import clsx from 'clsx';

/**
 * Persistent toast surfaced when a new SW is waiting. We never auto-
 * apply — reloading mid-form-entry would lose unsynced data. User
 * taps "Update" when they have a moment.
 */
export function UpdateBanner({ onAccept }: { onAccept: () => void }) {
  return (
    <div
      className={clsx(
        'sticky top-0 z-40 flex items-center justify-between gap-3 px-3 py-2',
        'border-b border-mono-700 bg-mono-800 text-mono-100 text-sm',
      )}
      role="alert"
    >
      <span>
        New version available. Restart when you have a moment to apply it.
      </span>
      <button
        type="button"
        onClick={onAccept}
        className="btn-primary px-3 py-1 text-sm"
      >
        Update
      </button>
    </div>
  );
}
